import React from 'react'
import "./Feature.css"
import { AiOutlineAntDesign } from 'react-icons/ai';
import { BsBarChartFill } from "react-icons/bs";
import { FaMobileAlt } from "react-icons/fa"
function Feature() {
    return (
        <div className=' feature-image'>
            <div className='container'>
                <div className=' d-flex justify-content-center pt-5 pb-5'>
                    <div className='col-10'>
                        <h4 className='feedbackhome-h4 text-white'>OUR FEATURES</h4>
                        <h2 className='feature-h2'>Understanding User Expectations
                         </h2>
                    </div>

                </div>
                <div class="row d-flex flex-wrap justify-content-center justify-content-md-between mt-5 pb-5" >
                    <div className='col-lg-4 col-11 pb-3' >
                        <a class="card1" >
                            <AiOutlineAntDesign size={80} style={{ color: "#eb4034" }} />
                            <h2 className='pt-2 feature-h22'>Creative Design</h2>
                            <p className=" pt-3 feature-pp" >We deliver modern, visually compelling, and brand-focused designs that enhance user engagement and strengthen brand identity. Our design process includes research, wireframing, and high-quality production with a focus on usability and mobile optimization.</p>
                        </a>
                    </div>
                    <div className='col-lg-4 col-11 pb-3'>
                        <a class="card1" >
                            <BsBarChartFill size={80} style={{ color: "#eb4034" }} />
                            <h3 className='pt-2 feature-h22'>Business Growth</h3>
                            <p className=" pt-3 feature-pp" >We focus on enabling business growth by leveraging modern technologies to improve operational efficiency, streamline processes, and support scalable digital transformation for businesses of all sizes.</p>
                        </a>
                    </div>
                    <div className='col-lg-4 col-11 pb-3'>
                        <a class="card1" >
                            <FaMobileAlt size={80} style={{ color: "#eb4034" }} />
                            <h3 className='pt-2 feature-h22'>Responsive Design</h3>
                            <p className=" pt-3 feature-pp" >We develop fully responsive, lightweight, and performance-optimized web designs that ensure a seamless user experience across all devices and screen sizes.</p>
                        </a>
                    </div>
                    {/* <div className='col-lg-4 col-10 pb-3'>
                        <a class="card1" >
                            <h3>This is option 1</h3>
                            <p class="small">Card description with lots of great facts and interesting details.</p>
                        </a>
                    </div> */}

                </div>
            </div>
        </div>
    )
}

export default Feature